import DateHelpers from 'helpers/Date';
import DateFormats from 'constants/dateFormats';
import { IFormDescriptorItem } from 'types/Analytics';
import { clampRelativePeriodForGroupByDate } from './utils';

export const VatAnalyticsOverview: IFormDescriptorItem[] = [
  {
    id: 'taxOverview',
    type: 'singleSelect',
    label: 'analytics.editForm.params.taxOverview.label',
    options: [
      {
        value: 'country',
        label: 'analytics.editForm.params.groupBy.filterByCountry.item',
      },
      {
        value: 'paymentMethod',
        label: 'analytics.editForm.params.groupBy.filterByPaymentMethod.item',
      },
    ],
  },
];
export const VatAnalyticsParams: IFormDescriptorItem[] = [
  {
    id: 'chartName',
    label: 'analytics.editForm.params.tableTitle.label',
    placeholder: 'analytics.editForm.params.tableTitle.placeholder',
    type: 'input',
  },
];

export const VatAnalyticsFilter: IFormDescriptorItem[] = [
  {
    id: 'period',
    type: 'date',
    label: 'analytics.editForm.params.period.label',
    renderOptions: {
      minDate: DateHelpers.createDate('01.01.2021', 'date').format(
        DateFormats.datetime
      ),
      enableRelativeMode: true,
    },
  },
  {
    id: 'groupByDate',
    type: 'singleSelect',
    label: 'analytics.editForm.params.groupPeriodBy.label',
    options: [
      {
        value: 'all',
        label: 'analytics.editForm.params.groupPeriodBy.noGroup.item',
      },
      {
        value: '1h',
        label: 'analytics.editForm.params.groupPeriodBy.hour.item',
        order: 1,
      },
      {
        value: '1d',
        label: 'analytics.editForm.params.groupPeriodBy.day.item',
      },
      {
        value: '1w',
        label: 'analytics.editForm.params.groupPeriodBy.week.item',
      },
      {
        value: '1m',
        label: 'analytics.editForm.params.groupPeriodBy.month.item',
      },
      {
        value: '3m',
        label: 'analytics.editForm.params.groupPeriodBy.quarter.item',
      },
    ],
    onChangeCallback: clampRelativePeriodForGroupByDate,
  },
  {
    id: 'paymentMethodType',
    type: 'multiSelect',
    label: 'analytics.editForm.params.groupBy.paymentMethodType.item',
    dictionaryKey: 'paymentMethod',
    renderOptions: {
      hidden: {
        condition: (values) => {
          if ('taxOverview' in values) {
            return values.taxOverview === 'country';
          }
          return false;
        },
      },
    },
  },
  {
    id: 'vatCountry',
    type: 'multiSelect',
    label: 'analytics.editForm.filters.country.label',
    dictionaryKey: 'country',
  },
  {
    id: 'vatState',
    type: 'multiSelect',
    label: 'analytics.editForm.filters.state.label',
    dictionaryKey: 'vatState',
    renderOptions: {
      hidden: {
        condition: (values) => {
          if ('vatCountry' in values) {
            return !(values.vatCountry.includes('US') || values.vatCountry.includes('CA'));
          }
          return false;
        },
      },
    },
  },
];
